export default __webpack_public_path__ + "static/media/SS.4aca8f8b.svg";